export const getItemPageNumber = <T>(item: T | undefined, allPages?: { data?: T[] }[]) => {
  if (!item || !allPages) return -1;
  for (let pageIdx = 0; pageIdx < allPages.length; pageIdx++) {
    if (allPages[pageIdx]?.data?.some((record) => record === item)) {
      return pageIdx + 1;
    }
  }
  return -1;
};

export const getItemIndex = <T>(item: T | undefined, allPages?: { data?: T[] }[]) => {
  if (!item || !allPages) return -1;
  const flatRecords = allPages.flatMap((page) => page?.data ?? []);
  return flatRecords.findIndex((record) => record === item);
};
